/* __next_internal_client_entry_do_not_use__ NotificationBellChecked auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=2918%3A732))
 * @trackcomponent
 * @lastsynced 2023-05-02T18:43:52.006Z
 */ export var NotificationBellChecked = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M9.17139 20.1328C9.32246 20.7136 9.66179 21.2278 10.1362 21.5948C10.6106 21.9618 11.1933 22.1609 11.7929 22.1609C12.3926 22.1609 12.9752 21.9618 13.4496 21.5948C13.9241 21.2278 14.2634 20.7136 14.4145 20.1328",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M19.179 9.30806C19.179 17.4171 22.0299 17.635 22.8 17.635H1.5C2.28646 17.635 5.121 17.4001 5.121 9.30806C5.121 7.37382 5.86155 5.51881 7.17975 4.1511C8.49794 2.78339 10.2858 2.01501 12.15 2.01501C13.3306 2.01501 14.4806 2.32318 15.5 2.89657",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M13.417 6.12507L15.5601 7.95248C15.6089 8.02735 15.6712 8.08819 15.7425 8.13049C15.8137 8.17279 15.8919 8.19547 15.9715 8.19687C16.051 8.19827 16.1298 8.17834 16.2021 8.13857C16.2743 8.09879 16.3381 8.04017 16.3888 7.96705L20.3232 1.98132",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "NotificationBellChecked", function(strictLocalize) {
    return {
        color: Core.icon.default,
        fill: "none",
        titleAccess: strictLocalize({
            id: "duJszp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Notification set"
                }
            ]
        }),
        viewBox: "0 0 24 24"
    };
});
